{
    "RandomiseTitle": "Palavra-passe aleatória",
    "PasswordStrength": "Força da palavra-passe:",
    "PasswordStrength_0": "Curto demais",
    "PasswordStrength_1": "Muito fraco",
    "PasswordStrength_2": "Fraco",
    "PasswordStrength_3": "Moderado",
    "PasswordStrength_4": "Forte",
    "PasswordStrength_5": "Muito forte",
    "NAME": "PasswordTextInput",
    "PasswordRequirements_Title": "Requisitos de palavra-passe:"
}